<template>
	<div class="status">
		<ul>
			<li v-for="(item, index) of status" :class="{'active': index + 1 <= step, 'current': index + 1 === step}" :key="index">
				<span>{{index + 1}}</span>
				<p v-html="item.join('<br/>')"></p>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
  name: 'StepStatus',
	props: {
		step: {
			default: 1,
			type: Number
		}
	},
	
  data() {
    return {
      status: [
        ['Application Form'],
        ['Interview', '& Demo'],
        ['New Teacher', 'Orientation'],
        ['New Teacher', 'Training'],
        ['Onboarding']
      ]
    }
  }
}
</script>

<style lang='less' scoped>
.status {
  width: 1000px;
  height: 70px;
  color: #535353;
  background-color: #fff;

  ul {
    margin-left: 29px;
    height: 100%;

    li {
      float: left;
      width: 235px;
      height: 100%;
      position: relative;
      background: url('~@img/status.png') no-repeat 0 -70px;
      margin-left: -29px;
      padding-left: 65px;
      line-height: 70px;
			box-sizing: border-box;
			
			&.current {
        color: #1e1e1e;
        
				p {
					font-weight: bold;
				}
			}

      &.active {
				background-position: 0 -140px;
      }

      span {
        font-size: 40px;
      }

      p {
        position: absolute;
        left: 96px;
        top: 50%;
        transform: translateY(-50%);
        white-space: nowrap;
        line-height: 20px;
      }

      &:nth-of-type(1) {
        width: 201px;
        background-position: 0 0;
        padding-left: 16px;

        p {
          left: 46px;
        }
      }

      &:nth-of-type(5) {
        &.active {
          background-position: 0 -280px;
				}
				
        width: 210px;
        background-position: 0 -210px;
        padding-left: 58px;

        p {
          left: 88px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// StepStatus.vue?37ddc73a